import { API_DOMAIN } from "@config";

export function prefixApiDomain(url) {
  return `${API_DOMAIN}${url}`;
}
